import React, { useRef } from "react";
import { useParams } from "react-router";
import TemplatePage from "../template";
import styles from "./product-shelf.module.scss";
import classNames from "classnames/bind";
import { useSearchParams } from "../../../hooks/useSearchParams";
import { useGetPageItemByIdQuery } from "../../../providers/page-items";
import { useProductShelfProducts } from "./use-product-shelf-products";

const cx = classNames.bind(styles);

interface RouteParams {
  id: string;
}

const ProductShelfPage = () => {
  const params = useParams<RouteParams>();
  const { get } = useSearchParams();
  const filterValue = get("additionalProductFilter");
  const additionalProductFilter = filterValue === null ? undefined : filterValue;
  const infiniteRef = useRef<HTMLIonInfiniteScrollElement | null>(null);

  const shlefQueryEnabled = !!params.id;

  const { data: shelf, isLoading: isFindProductsShelfLoading } = useGetPageItemByIdQuery(params.id, {
    enabled: shlefQueryEnabled,
  });

  const {
    products,
    additionalFilters,
    isLoading: isProductsDataLoading,
    isInfiniteQueryEnabled,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  } = useProductShelfProducts({ shelf, additionalProductFilter });

  const imageSrc = shelf?.images?.[0]?.src;
  const base64Image = shelf?.base64 || "";
  const isLoading = isFindProductsShelfLoading || isProductsDataLoading;
  const hasProducts = !isLoading && !!products.length;

  const handleShowMoreClick = async () => {
    if (isInfiniteQueryEnabled && hasNextPage) {
      await fetchNextPage();
    }
  };

  const handleIonInfinite = async () => {
    if (isInfiniteQueryEnabled && hasNextPage) {
      await fetchNextPage();
    }
    requestAnimationFrame(() => {
      infiniteRef.current?.complete();
    });
  };

  return (
    <TemplatePage
      products={products}
      filters={additionalFilters}
      hasProducts={hasProducts}
      isLoading={isLoading}
      infiniteRef={infiniteRef}
      className={cx("categoryImage")}
      showSearchButton={false}
      title={shelf?.title ?? ""}
      imageSrc={imageSrc ?? ""}
      base64Image={base64Image}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      onShowMoreClick={handleShowMoreClick}
      onIonInfinite={handleIonInfinite}
    />
  );
};

export default ProductShelfPage;
